import './assets/main.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import App from './App.vue'
import { useRouter } from '@/router'
import { onAuthExpired } from '@/util/auth-events'

import print from 'vue3-print-nb'

import { numberDirective, authDirective } from '@safety/shared-utils'

import { MySelect } from '@safety/shared-components'
import UserInfo from '@/components/UserInfo.vue'

import { useAuthStore } from '@/store/auth'

const app = createApp(App)

app.use(createPinia())
app.use(ElementPlus, { locale: zhCn })
app.use(print)

const authStore = useAuthStore()
authStore.init()

const router = useRouter(authStore)
app.use(router)

onAuthExpired(() => {
  const cur = router.currentRoute.value
  if (cur?.path === '/login') return
  router.replace({ path: '/login', query: { __prev: encodeURIComponent(cur?.fullPath || '/') } })
})

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.component('MySelect', MySelect)
app.component('UserInfo', UserInfo)

app.config.errorHandler = (err) => {
  console.error(err)
}

app.directive('number', numberDirective)
app.directive('auth', authDirective(authStore))

app.mount('#app')
